import { useState, useEffect } from 'react';
import axios from 'axios';

export const DEFAULT_TERMS = [
  'Parkeerkosten worden bij de laatste factuur berekend en afgerekend.',
  'Vergunningen worden altijd door de klant verzorgd.',
];

let cachedTerms = null;

export const StandardTermsBlock = () => {
  const [terms, setTerms] = useState(cachedTerms || DEFAULT_TERMS);
  useEffect(() => {
    if (cachedTerms) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/document-terms`)
      .then((r) => {
        if (Array.isArray(r.data?.terms)) {
          cachedTerms = r.data.terms;
          setTerms(r.data.terms);
        }
      })
      .catch(() => {});
  }, []);
  if (!terms || terms.length === 0) return null;
  return (
    <div style={{ padding: '10px 14px', background: '#f8f9fa', borderLeft: '3px solid #1a5276', borderRadius: '4px', fontSize: '11px', color: '#555', margin: '15px 0' }} data-testid="standard-terms-block">
      {terms.map((t, i) => (
        <p key={i} style={{ margin: '2px 0' }}>• {t}</p>
      ))}
    </div>
  );
};
